package com.devi3east.bashbuddy.purchase.responses

import com.devi3east.bashbuddy.purchase.domain.models.OrgSubPurchase
import com.devi3east.bashbuddy.purchase.domain.models.PurchaseStatus
import kotlinx.serialization.Serializable

@Serializable
data class PurchaseConfirmResponse(
    val purchaseId: String,
    val status: PurchaseStatus,
    val subPurchases: List<OrgSubPurchase> = emptyList(),
    val message: String? = null
)